import {
  FccAdAlertType,
  TaskNotificationSeverity,
} from '@backoffice-frontend/graphql'
import type {
  GetAlertSeverityAdAlertFragment,
  GetAlertSeverityTaskNotificationFragment,
} from './getAlertSeverity.hook'

export type AlertSeverity = 'Normal' | 'High' | 'Highest'

export const getAlertSeverity = (
  alert?:
    | GetAlertSeverityTaskNotificationFragment
    | GetAlertSeverityAdAlertFragment,
): AlertSeverity => {
  if (!alert) {
    return 'High'
  }

  if (isTaskNotification(alert)) {
    switch (alert.severity) {
      case TaskNotificationSeverity.High:
        return 'Highest'
      case TaskNotificationSeverity.Normal:
        return 'High'
      case TaskNotificationSeverity.Low:
        return 'Normal'
    }
  }

  switch (alert.type) {
    case FccAdAlertType.EmergencyStop:
    case FccAdAlertType.ServiceCancellationOngoing:
    case FccAdAlertType.VehicleGuidanceRequested:
      return 'Highest'
    case FccAdAlertType.PassengerUnbuckled:
    case FccAdAlertType.CabinSafetyCheck:
      return 'High'
    case FccAdAlertType.CabinToOperatorCall:
    case FccAdAlertType.OperatorToCabinCall:
    case FccAdAlertType.WaypointAttendance:
      return 'Normal'
    default:
      return 'High'
  }
}

export const isTaskNotification = (
  alert:
    | GetAlertSeverityTaskNotificationFragment
    | GetAlertSeverityAdAlertFragment,
): alert is GetAlertSeverityTaskNotificationFragment =>
  alert.__typename !== 'FccAdAlert'
